// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/* HBF-145: Figma \"label new\" - HF RED background, white Open Sans Semibold 11px */\n.outletTags-root-5oq {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: 4px;\n}\n\n.outletTags-root_pdp-hnU {\n    gap: 10px;\n}\n\n.outletTags-tag-Rba {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    padding: 6px 8px;\n    background-color: #af231c;\n    color: #ffffff;\n    font-size: 11px;\n    font-weight: 600;\n    line-height: normal;\n    letter-spacing: normal;\n    text-transform: uppercase;\n    white-space: nowrap;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": "outletTags-root-5oq",
	"root_pdp": "outletTags-root_pdp-hnU outletTags-root-5oq",
	"tag": "outletTags-tag-Rba"
};
export default ___CSS_LOADER_EXPORT___;
